export default function rgbToHex(rgb: string) {
  if (rgb[0] === '#') return rgb;

  const originalRGB = rgb.split(',');
  const to255 = (v: any) => (v <= 1 ? v * 255 : v);

  const channels = [...originalRGB].map(to255).map(Math.round);

  const toHex = (v: any) => v.toString(16).padStart(2, '0');

  return '#' + channels.map(toHex).join('');
}
